import React from 'react';
import {IQuote} from "../../../../../../../app/interfaces/quote/IQuote";
import {useTranslation} from "react-i18next";

type LiquidityFieldProps = {
    quote: IQuote;
}

const spanStyle: React.CSSProperties = {
    color: 'white',
    backgroundColor: 'var(--red-color)',
    padding: '2px 10px',
    borderRadius: '24px'
}

const LiquidityField: React.FC<LiquidityFieldProps> = ({
                                                           quote
                                                       }) => {
    const {t} = useTranslation();

    if (!quote.isLiquidity) {
        return null;
    }

    return (
        <div className={'details-box-item-field-value liquidity-value'}>
            <span style={spanStyle}>
                {t("quote.form.liquidity")}
            </span>
        </div>
    );
};

export default LiquidityField;
